import styled, { css } from 'styled-components';

import { mediaWide, mediaConfined } from '@xing-com/layout-tokens';
import {
  scale130,
  scale330,
  spaceXXL,
  space3XL,
  space4XL,
  space5XL,
  spaceXS,
  scale150,
  spaceL,
  scale380,
  scale170,
  spaceXL,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const baseWidth = '1520px';

export const SubpageLayout = styled.div<{ $showBreadcrums?: boolean }>`
  display: flex;
  flex-direction: column;

  max-width: calc(${baseWidth} + ${scale130} * 2);
  width: 100%;
  ${({ $showBreadcrums }) => css`
    padding: ${$showBreadcrums ? '0px' : spaceXL} ${spaceL} ${scale170};
  `}
  margin: 0 auto;

  @media ${mediaConfined} {
    ${({ $showBreadcrums }) => css`
      padding: ${$showBreadcrums ? '0px' : spaceXL} ${spaceXXL} ${scale330};
    `}
  }
  @media ${mediaWide} {
    ${({ $showBreadcrums }) => css`
      padding: ${$showBreadcrums ? '0px' : spaceXL} ${spaceXXL} ${scale380};
    `}
  }
`;
export const ButtonLayout = styled.div`
  margin-bottom: ${spaceXXL};

  @media ${mediaWide} {
    margin-bottom: ${space4XL};
  }
`;
export const HeaderLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXS};
  margin-bottom: ${space3XL};

  max-width: calc(${baseWidth} / 2);

  @media ${mediaConfined} {
    margin-bottom: ${space4XL};
  }
  @media ${mediaWide} {
    margin-bottom: ${space5XL};
  }

  & > * {
    margin: 0;
  }
`;
export const HeaderLayoutHeadline = styled(Headline).attrs({
  as: 'h1',
})`
  line-height: 38px;

  @media ${mediaConfined} {
    line-height: 50px;
    font-size: ${scale150};
  }

  @media ${mediaWide} {
    line-height: 50px;
    font-size: ${scale150};
  }
`;
